import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export const ENABLE_EVENT_TRIGGERED_CREATE_APPOINTMENT_DIALOG = 'enable-event-triggered-create-appointment-dialog';

export function useEventTriggeredCreateAppointmentDialogFeature() {
  const flag = useFlag(ENABLE_EVENT_TRIGGERED_CREATE_APPOINTMENT_DIALOG);

  return {
    isEventTriggeredCreateAppointmentDialogEnabled: computed(() => Boolean(flag.value?.ready && flag.value?.enabled))
  };
}
